import React from 'react';

export interface IFeideIconProps {
  width?: string;
  height?: string;
  viewBox?: string;
}

const FeideIconColored: React.FC<IFeideIconProps> = ({
  width = '24',
  height = '24',
  viewBox = '6 6 44 44',
}) => {
  return (
    <svg
      role="img"
      width={width}
      height={height}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sign in with Feide</title>
      <rect fill="#FFFFFF" x="6" y="6" width="44" height="44"></rect>
      <g transform="translate(20.562 19) scale(0.46154)" fill="#1f4698">
        <rect x="27.99" y="20.34" width="4.24" height="10.18"></rect>
        <polygon points="18.23 23.31 13.99 23.31 13.99 34.76 4.24 34.76 4.24 20.34 0 20.34 0 35.61 0.02 35.61 0.02 39 32.23 39 32.23 34.76 18.23 34.76 18.23 23.31"></polygon>
        <circle cx="16.11" cy="16.53" r="2.54"></circle>
        <path d="M16.11,4.24A11.87,11.87,0,0,1,28,16.1h4.25A16.11,16.11,0,0,0,0,16.1H4.25A11.87,11.87,0,0,1,16.11,4.24Z"></path>
      </g>
    </svg>
  );
};

export default FeideIconColored;
